export const Get_Token = () => {
    let token = window.localStorage.getItem('token');
    return token;
};
